// @flow
import React from 'react'
import { Authors } from '../Authors'
import { getPublishingDate } from '@ta-interaktiv/api-access'
import headerImage from './images/hunde.svg'
import './styles.scss'

const pubFormat = new Intl.DateTimeFormat('de', {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
})
const dateNow = new Date()

export class Header extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      publishingDate: pubFormat.format(dateNow)
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    // console.log('tenant:', this.props.tenant)
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()

    getPublishingDate(this.props.tenant.domain, this.props.articleID).then(pubDate => {
      let pDate = Date.parse(pubDate)
      this.setState({publishingDate: pubFormat.format(pDate)})
    })
  }

  render() {
    console.log('this.props.tenant:', this.props.tenant)
    return <div className='header'>

        <div className='title-wrapper'>
          <div className='titles'>
            <h1 dangerouslySetInnerHTML={{__html: this.state.isMobile ? this.props.titleMobile : this.props.title}}></h1>
          </div>
        </div>

        <div className="authors">
            <Authors authors={[
              {name: 'Yannick Wiget', unityID:'28754714'},
              {name: 'Mathias Lutz', unityID:'95724327'},
            ]}
            tenant={this.props.tenant} />
            <div className='publication'>
            Publiziert am {this.state.publishingDate}
          </div>
        </div>

      {/* Image Header */}
      <div className="header-image">
        <img src={headerImage} alt='header' />
        <div className="source">Illustration: Klaudia Meisterhans</div>
      </div>

      {/* <h2>{this.props.lead}</h2> */}

    </div>
  }
}
